import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'business-issue-field-statistics.tooltip',
		defaultMessage: 'View as chart',
		description:
			'Explains to the user that on click the issue field statistics will be displayed as a chart',
	},
	errorFlagTitle: {
		id: 'business-issue-field-statistics.error-flag-title-non-final',
		defaultMessage: 'Something went wrong',
		description:
			'Title of the flag displayed when an unexpected error is caught by the error boundary.',
	},
	errorFlagDescription: {
		id: 'business-issue-field-statistics.error-flag-description-non-final',
		defaultMessage: "We couldn't open the chart. Please try again or contact support.",
		description:
			'Title of the flag displayed when an unexpected error is caught by the error boundary.',
	},
	errorFlagContactSupportActionText: {
		id: 'business-issue-field-statistics.error-flag-contact-support-action-text-non-final',
		defaultMessage: 'Contact support',
		description:
			'The text of the link displayed in the flag for the user to click on to open the contact support page.',
	},
	chartButtonLabel: {
		id: 'business-issue-field-statistics.chart-button-label',
		defaultMessage: 'Chart',
		description: 'Label of the button to open the issue field statistics chart',
	},
});
